import API from "api/api/API";
import Cookies from "js-cookie";
import TenantAPI from "./TenantAPI";

export default class FilterAPI {
  static async createCRMFilter(name, description, query, moduleAPIName) {
    const payload = {
      Name: name,
      Description: description,
      Query: query,
    };

    return API._bearerRequest(
      "post",
      `/tenant/crm/records/${moduleAPIName}/filters`,
      payload,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async getAllCRMFilters() {
    return API._bearerRequest(
      "get",
      "/tenant/crm/filters",
      null,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async getCRMFiltersByModuleName(moduleAPIName) {
    return API._bearerRequest(
      "get",
      `/tenant/crm/records/${moduleAPIName}/filters/get`,
      null,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async getCRMFilterByID(filterID) {
    return API._bearerRequest(
      "get",
      `/tenant/crm/filters/${filterID}`,
      null,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async modifyCRMFilterByID(name, description, query, filterID) {
    const payload = {
      Name: name,
      Description: description,
      Query: query,
    };

    return API._bearerRequest(
      "put",
      `/tenant/crm/filters/${filterID}`,
      payload,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async deleteCRMFilterByID(filterID) {
    return API._bearerRequest(
      "delete",
      `/tenant/crm/filters/${filterID}`,
      null,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async cloudSearch({ searchedValue, moduleFilters, pagination }) {
    const payload = {
      searchedValue: searchedValue,
      moduleFilters: moduleFilters,
      pagination: pagination,
    };
    return API._bearerRequest(
      "post",
      `/tenant/crm/cloudSearch`,
      payload,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }
}
